import GenerationStatus from '../GenerationStatus';

interface AgencyAgreementGeneratingProps {
  generationStatus: GenerationStatus;
  generatingText?: string;
}

const AgencyAgreementGenerating = ({
  generationStatus,
  generatingText = 'Generating Agreement',
}: AgencyAgreementGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return generatingText;
  }

  if (generationStatus === GenerationStatus.Generated) {
    return 'Complete';
  }
};

export default AgencyAgreementGenerating;
